import request from "./request";
/**
 * 获取用户与AppId绑定关系
 */
export default async function getPlayerAppIdBind() {
  return await request.get("/spin/dataBusiness/getPlayerAppIdBind", {});
}
